export default __webpack_public_path__ + "static/media/main-require.a7ae4285.cjs";